import { Box, Flex, Grid, Progress, Text } from "@chakra-ui/react";
import { rateFooter } from "../../helpers/goals";
import GoalCard from "./GoalCard";

// Segments beat a bar at small counts; above this a bar reads better.
const MAX_SEGMENTS = 14;

/**
 * One segment per issue in the period, or a bar for larger monthly targets.
 */
const RateGoalCard = ({ goal, onManage }) => {
  const progress = goal.progress || {};
  const target = Math.max(Number(progress.target ?? goal.targetCount) || 0, 1);
  const completed = Math.min(Number(progress.completed) || 0, target);
  const useSegments = target <= MAX_SEGMENTS;
  const segments = useSegments ? target : 0;
  const filled = Math.round((completed / target) * segments);
  const isPaused = goal.status === "paused";

  return (
    <GoalCard
      goal={goal}
      onManage={onManage}
      subtitle={isPaused ? rateFooter(goal) : undefined}
    >
      {!isPaused && (
        <>
          {useSegments ? (
            <Grid
              aria-label={`${completed} of ${target} this period`}
              gap="2"
              mt="4"
              templateColumns={`repeat(${segments}, minmax(0, 1fr))`}
            >
              {Array.from({ length: segments }, (_, index) => (
                <Box
                  bg={index < filled ? "red.500" : "#2E3A59"}
                  borderRadius="md"
                  h={segments > 10 ? "18px" : "44px"}
                  key={index}
                />
              ))}
            </Grid>
          ) : (
            <Box mt="4">
              <Progress
                aria-label={`${completed} of ${target} this period`}
                bg="#2E3A59"
                borderRadius="full"
                colorScheme="red"
                size="sm"
                value={(completed / target) * 100}
              />
              <Flex justify="space-between" mt="2">
                <Text color="gray.300" fontSize="sm">
                  {completed} of {target}
                </Text>
              </Flex>
            </Box>
          )}
          <Text color="gray.400" fontSize="sm" mt="3">
            {rateFooter(goal)}
          </Text>
        </>
      )}
    </GoalCard>
  );
};

export default RateGoalCard;
